module.exports = __webpack_public_path__ + "img/dusk_icon.410b1028.svg";